<template lang="pug">
	section#page-error
		.box
			h1.title(ref="title", tabindex="-1") {{ title }}
			p.message {{ message }}
			.actions(v-if="retryable || to")
				button.squareButton(v-if="retryable", type="button", @click="$emit('retry')") Tentar novamente
				router-link.back(v-if="to", :to="to") {{ linkLabel }}
</template>

<script>
export default {
	name: "component-page-error",
	props: {
		title: {
			type: String,
			required: true,
		},
		message: {
			type: String,
			default: ``,
		},
		// Mostra o botão "Tentar novamente", que emite `retry`
		retryable: {
			type: Boolean,
			default: false,
		},
		to: {
			type: [String, Object],
			default: null,
		},
		linkLabel: {
			type: String,
			default: ``,
		},
	},
	// O conteúdo anterior some junto com o foco: leva o foco (e o leitor de tela) ao título
	mounted() {
		this.$refs.title.focus({ preventScroll: true })
	},
}
</script>

<style lang="stylus" scoped src="./PageError.styl"></style>
